import { factChecks, type FactCheckRow } from "@/mocks/home";
import SectionHead from "./SectionHead";

const STYLE: Record<FactCheckRow["status"], { label: string; cls: string; txt: string }> = {
  cleared: { label: "已辟谣", cls: "bg-secondary-500/15 text-secondary-300 border-secondary-500/30", txt: "text-secondary-300" },
  responding: { label: "已回应", cls: "bg-accent-500/15 text-accent-300 border-accent-500/30", txt: "text-accent-300" },
  unproven: { label: "无实据", cls: "bg-primary-500/15 text-primary-300 border-primary-500/30", txt: "text-primary-300" },
  checking: { label: "待核实", cls: "bg-background-300/50 text-foreground-500 border-background-300/60", txt: "text-foreground-500" },
};

export default function FactCheckSection() {
  return (
    <section id="factcheck" className="border-y border-background-200/70 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          eyebrow="辟谣核查清单"
          accent
          title="一条网传说法，对照到它到底站不站得住"
          desc="把流传的说法、它的来源与我们目前能核到的状态并列呈现：是旧闻重发、无实据，还是已有当事人与平台的一手澄清。"
          right={
            <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-600">
              <span className="rounded-full bg-background-200/60 px-2.5 py-1">收录 {factChecks.length} 条</span>
              <span className="rounded-full bg-background-200/60 px-2.5 py-1">口径随进展更新</span>
            </div>
          }
        />

        <div className="mt-7 overflow-hidden rounded-lg border border-background-200/70">
          {/* column header */}
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200/70 bg-background-200/40 px-5 py-3 text-xs font-semibold text-foreground-600 md:grid">
            <div className="col-span-4">网传说法</div>
            <div className="col-span-2">主要来源</div>
            <div className="col-span-2">核查状态</div>
            <div className="col-span-1 text-center">结论</div>
            <div className="col-span-3">说明</div>
          </div>

          {factChecks.map((row, i) => {
            const s = STYLE[row.status];
            return (
              <div
                key={row.id}
                className={`grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-12 md:gap-4 md:items-center ${
                  i !== factChecks.length - 1 ? "border-b border-background-200/60" : ""
                } ${i % 2 === 0 ? "bg-background-100/40" : "bg-background-50"}`}
              >
                <div className="col-span-1">
                  <div className="flex items-center justify-between gap-2 md:hidden">
                    <span className={`rounded-md px-2 py-0.5 text-[11px] ${s.cls}`}>{s.label}</span>
                    <span className="text-[11px] text-foreground-500">{row.source}</span>
                  </div>
                </div>
                <div className="col-span-4">
                  <div className="font-heading text-sm font-bold text-foreground-950 md:text-[15px]">{row.claim}</div>
                  <div className="mt-1 text-xs text-foreground-500 md:hidden">{row.source}</div>
                </div>
                <div className="col-span-2 hidden text-sm text-foreground-600 md:block">{row.source}</div>
                <div className="col-span-2 hidden md:block">
                  <span className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] ${s.cls}`}>
                    {s.label}
                  </span>
                </div>
                <div className="col-span-1 hidden md:block">
                  <span className={`font-heading text-sm font-black ${s.txt}`}>{row.conclusion}</span>
                </div>
                <div className="col-span-3 mt-1 text-xs leading-relaxed text-foreground-600 md:mt-0">{row.note}</div>
              </div>
            );
          })}
        </div>

        <p className="mt-4 text-center text-[11px] text-foreground-600">
          核查口径随新增公开信息持续更新；点击「常见问题」可查看我们如何判定状态。
        </p>
      </div>
    </section>
  );
}